import { useAppFeatures } from '../../redux/hooks';

export const useFeatures = () => {
  const {
    isCSCEnabled,
    isCNEdEnabled,
    isNLRValidationEnabled,
    isAIDETValidationEnabled,
    isBSSRValidationEnabled
  } = useAppFeatures();

  return {
    isCSCEnabled,
    isCNEdEnabled,
    isNLRValidationEnabled,
    isAIDETValidationEnabled,
    isBSSRValidationEnabled
  };
};
